import { render } from "./ExpenseMoney.vue?vue&type=template&id=0bcea4d6&scoped=true"
import script from "./ExpenseMoney.vue?vue&type=script&lang=js"
export * from "./ExpenseMoney.vue?vue&type=script&lang=js"

import "./ExpenseMoney.vue?vue&type=style&index=0&id=0bcea4d6&scoped=true&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcea4d6"]])

export default __exports__